<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Good Enough to Dream</h1>
</div>
</div>
<h3 style="text-align: center;">
<br/>
	By Roger Kahn</h3>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap81838.vue?b6fd6a34